<template>
  <div id="heroheader">
    <div class="heroheader-slide">
      <div class="slide-tx">
        <a
          :href="'#' + 'pickup'"
          v-smooth-scroll="{
            duration: 500,
            offset: -60,
            updateHistory: false,
          }"
        >
          <p class="sticker">GW期間も開催中！</p>
          <h3>春の新生活 大内覧会</h3>
          <p class="button">詳しくはこちら</p>
        </a>
      </div>
      <swiper
        :modules="modules"
        :slides-per-view="1"
        :loop="true"
        :speed="500"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
        }"
        :breakpoints="breakpoints"
      >
        <swiper-slide>
          <div class="imgwrap">
            <img class="pc" src="images/banner/nagai24spring-slide.jpg" />
            <img class="sp" src="images/banner/nagai24spring-slide-sp.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="imgwrap"><img src="images/jikiba5a/gal/01.jpg" /></div>
        </swiper-slide>
        <swiper-slide>
          <div class="imgwrap"><img src="images/jikiba5b/gal/01.jpg" /></div>
        </swiper-slide>
        <swiper-slide>
          <div class="imgwrap"><img src="images/jikiba5c/gal/02.jpg" /></div>
        </swiper-slide>
        <swiper-slide>
          <div class="imgwrap"><img src="images/jikiba5d/gal/01.jpg" /></div>
        </swiper-slide>
        ...
      </swiper>
    </div>
    <div class="heroheader-tx">
      <h2>SIMPLE & COMFORTABLE</h2>
      <h3>
        <span>快適な暮らしは、</span>
        <span>快適な新居で</span>
      </h3>
      <p>
        <span>快適な暮らしを</span>
        <span>実現する</span>
        <span>充実の設備を</span>
        <span>持った住まいの</span>
        <span>ご提案。</span>
        <span>「暮らしやすさ」を</span>
        <span>考え抜いた設計で、</span>
        <span>あなたの生活を</span>
        <span>応援いたします。</span>
      </p>
      <div id="information">
        <Information />
      </div>
    </div>
  </div>
</template>

<script>
import Information from "@/components/HeaderInformation.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper";

export default {
  components: {
    Information,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>

<style lang="scss" scoped>
.pc {
  @include tb {
    display: none;
  }
}
.sp {
  display: none;
  @include tb {
    display: block;
  }
}
#heroheader {
  width: 100%;
  height: 85vmin;
  position: relative;
  margin-bottom: calc($v-gap/2);
  @include tb {
    height: auto;
  }
  .heroheader-tx {
    width: 34%;
    height: 100%;
    padding: calc($h-gap * 2) calc($h-gap / 2) $h-gap $h-gap;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include tb {
      position: relative;
      width: 100%;
      padding: 0 $h-gap;
      margin-top: -4vw;
    }
    h2 {
      font-weight: bold;
      color: $color_blue;
      font-size: 5vw;
      line-height: 1;
      letter-spacing: -0.02em;
      @include tb {
        font-size: 11vw;
      }
    }
    h3 {
      color: $color_blue;
      font-weight: bold;
      font-size: clamp(1.5rem, 1.5vw, 1.8rem);
      margin: 0.5em 0;
      line-height: 1.5;
      @include tb {
      }
      span {
        display: inline-block;
      }
    }
    p {
      font-weight: bold;
      line-height: 2;
      margin-bottom: 2rem;
      span {
        display: inline-block;
      }
    }
  }
  .heroheader-slide {
    width: 66%;
    height: 85vmin;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    border-bottom-left-radius: $h-gap;
    overflow: hidden;
    @include tb {
      position: relative;
      width: calc(100% - $h-gap);
      height: 100vmin;
      margin-left: $h-gap;
      border-bottom-left-radius: 20vw;
    }
    .imgwrap {
      width: 100%;
      height: 85vmin;
      @include tb {
        height: 100vmin;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .slide-tx {
      position: absolute;
      background: rgba(255, 255, 255, 0.9);
      right: 0;
      bottom: 1rem;
      z-index: 2;
      font-size: clamp(0px, 2.25vw, 1rem);
      transition: 0.2s;
      &:hover {
        padding-right: 1em;
      }
      .sticker {
        font-size: 1em;
        font-weight: bold;
        margin-bottom: 0.25em;
        display: block;
      }
      h3 {
        font-weight: bold;
        font-size: 1.2em;
        display: inline-block;
        margin-right: 1rem;

        @include tb {
          display: block;
          margin-bottom: 0.5em;
        }
      }
      p.button {
        background-color: $color_red;
        color: white;
        padding: 0.5em 1.5rem 0.25em 1.5rem;
        display: inline-block;
        text-align: center;
        font-weight: bold;
        border-radius: 0.2em;
      }
      a {
        width: 100%;
        height: 100%;
        padding: 1.2rem;
        display: block;
      }
    }
  }
}
#information {
  margin-top: auto;
}
</style>
